window.CustomThemeModules = window.CustomThemeModules || {};

CustomThemeModules.VariantDimensions = (function () {
  const selectors = {
    dimensionContainer: '#dimension-details',
    variantInput: 'input[name="id"]',
    length: '#dimension-length',
    width: '#dimension-width',
    height: '#dimension-height',
    noDimensionsMessage: '.no-dimensions-msg',
  };

  function getVariantData(container) {
    try {
      return JSON.parse(container.dataset.variantDimensions);
    } catch (e) {
      console.warn('Invalid JSON in data-variant-dimensions');
      return {};
    }
  }

  function updateDimensions(variantId, data) {
    const dims = data[variantId];

    document.querySelector(selectors.length).textContent = '';
    document.querySelector(selectors.width).textContent = '';
    document.querySelector(selectors.height).textContent = '';
    document.querySelector(selectors.noDimensionsMessage).textContent = '';

    if (dims) {
      const { length, width, height } = dims;
      const hasAllDims = length && width && height;

      if (hasAllDims) {
        document.querySelector(selectors.length).textContent = length + 'cm x ';
        document.querySelector(selectors.width).textContent = width + 'cm x ';
        document.querySelector(selectors.height).textContent = height + 'cm';
      } else {
        document.querySelector(selectors.noDimensionsMessage).textContent = 'Not available';
      }
    }
  }

  function init() {
    const container = document.querySelector(selectors.dimensionContainer);
    const variantInput = document.querySelector(selectors.variantInput);

    if (!container || !variantInput) return;

    const variantData = getVariantData(container);
    if (!variantData) return;

    updateDimensions(variantInput.value, variantData);

    const observer = new MutationObserver(() => {
      updateDimensions(variantInput.value, variantData);
    });

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value'],
    });
  }

  return {
    init,
  };
})();
